import { Component } from '@angular/core';

@Component({
  selector: 'app-journey-of-pdf',
  imports: [],
  templateUrl: './journey-of-pdf.component.html',
  styleUrl: './journey-of-pdf.component.css'
})
export class JourneyOfPdfComponent {

}
